import { ApiService } from '../../services'
import { Unauthorized } from '../../helpers/unauthorized.handler'
export const MaterialModule = {
    namespaced: true,
    state: {
        loading: false,
        Deleteloading: false,
        data: {
            columns: [
                {
                    label: 'ID',
                    field: 'mdbID',
                    sort: 'asc',
                    width : '100px',
                    clickable: true
                },
                {
                    label: 'Name',
                    field: 'name',
                    sort: 'asc',
                    clickable: true
                },
                
            ],
            rows: [],
        },
        length: 25,
        page: 0,
        total: 1,
        searchTerm: null,
        filters: {},

        formStatus: 'create',
        formRecord: {},
        all : [],
        allMaterialsLoading : false
    },
    actions: {

        async getMaterials(_, params) {
            return await new Promise((resolve,reject) => {
                ApiService.get('material/filter', params).then((response) => {
                    const res = []
                    if (response.data.length > 0) {
                        response.data.forEach((element) => {
                            const row = { label: element.name, value: element.mdbID, slug: element.slug,attributes: [] }
                            res.push(row)
                        })
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        async getAllMaterials({commit}, params) {
            commit('setAllMaterialsLoading',true)
            return await new Promise((resolve,reject) => {
                ApiService.get('material/all', params).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    commit('setAllMaterialsLoading',false)
                    reject(error)
                })
            })
        },

        async asyncGetData({ rootState, commit, dispatch }) {
            const { loading, length, page, filters, searchTerm } = rootState.MaterialModule
            return await new Promise((resolve) => {
                if (loading === false) {
                    commit('LoadingTrue')
                    const params = { length: length, page: page, term: searchTerm, filters: filters }
                    ApiService.get('material/data', params).then((response) => {
                        commit('SetPage', response.data.current_page)
                        commit('SetTotal', response.data.total)
                        commit('SetData', response.data.data)
                        commit('LoadingFalse')
                        resolve(response.data.data)
                    }).catch(error => {
                        //reject(error)
                        Unauthorized(dispatch, error)
                    })
                }
            })
        },

        async StoreRecord({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.MaterialModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    ApiService.store('material', payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },

        async createOrUpdate({ commit,state }, payload) {
            commit('LoadingTrue')
            return await new Promise((resolve, reject) => {
                ApiService.store('material/create-or-update', payload).then((response) => {
                    commit('LoadingFalse')
                    const responseBody = response.data;
                    resolve(responseBody)
                }).catch((error) => {
                    commit('LoadingFalse')
                    reject(error)
                })
            })
        },
        UpdateRecord({ rootState, commit }, payload) {
            var self = this
            return new Promise((resolve, reject) => {
                const loading = rootState.MaterialModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    ApiService.update('material', payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async DeleteRecord({ rootState, commit }, payload) {
            var self = this
            return await new Promise((resolve, reject) => {
                const loading = rootState.MaterialModule.Deleteloading;
                if (!loading) {
                    commit('DeleteloadingTrue')
                    const tokens = [];
                    payload.forEach(element => {
                        tokens.push(element.token_id)
                    });
                    ApiService.deleteSelected('material', tokens).then((response) => {
                        commit('DeleteloadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('DeleteloadingFalse')
                        reject(error)
                    })
                }
            })
        }
    },
    mutations: {
        LoadingFalse: (state) => {
            state.loading = false
        },
        LoadingTrue: (state) => {
            state.loading = true
        },
        DeleteloadingFalse: (state) => {
            state.Deleteloading = false
        },
        DeleteloadingTrue: (state) => {
            state.Deleteloading = true
        },
        SetData(state, payload) {
            state.data.rows = payload
        },
        SetPage: (state, payload) => {
            state.page = payload
        },
        SetTotal: (state, payload) => {
            state.total = payload
        },
        SetLength: (state, payload) => {
            state.length = payload
        },
        SetCode: (state, payload) => {
            state.form.item_code = payload
        },

        SetFormStatusCreate: (state) => {
            state.formStatus = 'create'
        },

        SetFormStatusUpdate: (state) => {
            state.formStatus = 'update'
        },
        SetFormRecord: (state, payload) => {
            state.formRecord = payload
        },

        setAllMaterials: (state, payload) => {
            state.all = payload || []
        },
        setAllMaterialsLoading: (state, payload) => {
            state.allMaterialsLoading = payload
        }

    },
    getters: {
        Loading: state => state.loading,
        Deleteloading: state => state.Deleteloading,
        dialogIsOpen: state => state.dialogIsOpen,
        data: state => state.data,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        form: state => state.form,
        columns: state => state.data.columns,
        FormStatus: state => state.formStatus,
        FormRecord: state => state.formRecord,
        allMaterials: state => state.all,
        allMaterialsLoading: state => state.allMaterialsLoading
    }
}


